export default function RailMoreOptions(
    $compile,
    $templateRequest,
    userService,
    l10nService,
    authService,
    railsApiService,
) {
    'ngInject';

    return {
        restrict: 'AE',
        scope: {
            options: '=options',
            params: '=params',
            railsSearch: '=form',
            showOptions: '=show',
            disabled: '=disabled',
            templateUrl: '@templateUrl',
        },
        link: function(scope, element) {
            scope.availableServices = authService.getAvailableServicesFromSessionStorage();
            scope.l10n = l10nService;
            scope.isUSRegion = userService.isUSRegion();
            scope.isUKRegion = userService.isUKRegion();
            scope.blankRailCardMsg = '';

            /**
             * "KT Charity fares only" option visible only for UK users
             * @type {boolean}
             */
            scope.isFaresOptionVisible = userService.isUKRegion();

            getStaticDataForGoAvoid();

            scope.euroStarChange = function() {
                scope.params.IncludeEuroStar = !scope.params.IncludeEuroStar;
            };

            scope.formatLabel = function(model) {
                const length = scope.options.airlines.length;
                let code = null;
                for (let i = 0; i < length; i++) {
                    if (model === scope.options.airlines[i].Code) {
                        code = scope.options.airlines[i].Name;
                    }
                }
                return code;
            };

            scope.toggleShowOptions = function() {
                scope.showOptions = !scope.showOptions;
            };

            $templateRequest(scope.templateUrl).then(function(html) {
              element.html(html).show();
              $compile(element.contents())(scope);
            });

            scope.getTravellersCount = function() {
                return parseInt(scope.params.Travelers.Adult.value, 10);
            };

            scope.validateGoViaAvoidStation = function(ctrl, controlName) { // eslint-disable-line
                if (controlName === '_address3') {
                    ctrl.railsSearch._address3.$error.selectGoViaStation = false;
                    ctrl.railsSearch._address3.$setValidity('selectGoViaStation', true);
                    ctrl.railsSearch._address3.$error.invalidGoViaStation = false;
                    ctrl.railsSearch._address3.$setValidity('invalidGoViaStation', true);
                    ctrl.railsSearch.$valid = true;
                    if (scope.params.GoViaOrAvoidRailStation
                        && scope.params.RailTicketSearchSegments[0]._departure
                        && scope.params.RailTicketSearchSegments[0]._arrival) {
                        if (scope.params.GoViaOrAvoidRailStation.Code === scope.params.RailTicketSearchSegments[0]._departure.Code
                        || scope.params.GoViaOrAvoidRailStation.Code === scope.params.RailTicketSearchSegments[0]._arrival.Code) {
                        ctrl.railsSearch._address3.$error.invalidGoViaStation = true;
                        ctrl.railsSearch.$valid = false;
                        }
                    }
                    if (scope.params.GoViaOrAvoidRailStation === null
                        || angular.isUndefined(scope.params.GoViaOrAvoidRailStation)
                        || scope.params.GoViaOrAvoidRailStation === '') {
                        ctrl.railsSearch._address3.$error.selectGoViaStation = true;
                        ctrl.railsSearch._address3.$setValidity('selectGoViaStation', false);
                        ctrl.railsSearch.$valid = false;
                    }
                }
            };

            scope.validateGoVia = function(ctrl) {
                if (ctrl.railsSearch._address3) {
                    ctrl.railsSearch._address3.$error.selectGoViaStation = false;
                    ctrl.railsSearch._address3.$error.invalidGoViaStation = false;
                    ctrl.railsSearch._address3.$setValidity('selectGoViaStation', true);
                    ctrl.railsSearch._address3.$setValidity('invalidGoViaStation', true);
                    ctrl.railsSearch.$valid = true;
                    if (angular.isDefined(scope.params.GoViaOrAvoid)) {
                        if (scope.params.GoViaOrAvoid.Value !== '') {
                            if (scope.params.GoViaOrAvoidRailStation === null || scope.params.GoViaOrAvoidRailStation === '') {
                                ctrl.railsSearch._address3.$error.selectGoViaStation = true;
                                ctrl.railsSearch._address3.$setValidity('selectGoViaStation', false);
                                ctrl.railsSearch.$valid = false;
                            }
                        }
                        if (scope.params.GoViaOrAvoid.Value === '') {
                            scope.params.GoViaOrAvoidRailStation = '';
                        }
                    }
                }
            };

            function getStaticDataForGoAvoid() {
                railsApiService.getStaticData().then(function(response) {
                    scope.StaticDataList = response.data;
                    scope.StaticDataList.GoVias.splice(0, 0, {Text: 'None', Value: ''});
                    scope.StaticDataList.GoVias = _.map(scope.StaticDataList.GoVias, (item) => ({Text: l10nService.localize(item.Text), Value: item.Value}));
                    scope.options.ukRailGoViaAvoidOptions = scope.StaticDataList.GoVias;
                    if (angular.isUndefined(scope.params.GoViaOrAvoid)) {
                        scope.params.GoViaOrAvoid = scope.options.ukRailGoViaAvoidOptions[0];
                    }
                });
            }

            scope.getLocation = function(searchString) {

                scope.railStations = [];

                if (searchString && searchString.length < 2) {
                    return scope.railStations;
                }

                /**
                 * Expected request data
                 */
                const requestData = {
                    params: {searchPattern: searchString},
                    noSpinner: true,
                };

                return railsApiService.searchLocation(requestData).then(function(response) {
                    return response.data;
                });
            };

            scope.euRailsCardsVisible = false;

            scope.$watchGroup(['params.RailTicketSearchSegments[0]._departure.Code', 'params.RailTicketSearchSegments[0]._arrival.Code'], function() {
                const departure = scope.params.RailTicketSearchSegments[0]._departure;
                const arrival = scope.params.RailTicketSearchSegments[0]._arrival;

                scope.euRailsCardsVisible = departure && departure.Code.startsWith('urn:') || arrival && arrival.Code.startsWith('urn:');
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/base/directives/ktRailMoreOptions.directive.js